// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"index-module__tableContainer___2xdr4","header":"index-module__header___27Tma","body":"index-module__body___3ZXJ6"};